/* Match the app's Design Color control to Craft without moving its order input. */
(() => {
  if (window.dfcDesignColorReady) return;
  window.dfcDesignColorReady = true;
  let pending = false;
  const bindings = new WeakMap();
  const normalize = value => String(value || '').replace(/\*/g, '').trim().toLowerCase();

  function arrange() {
    pending = false;
    document.querySelectorAll('product-info').forEach(info => {
      const picker = info.querySelector('variant-selects');
      const clean = picker?.querySelector('.dfc-clean-picker');
      if (!clean) return;
      const colorField = Array.from(clean.querySelectorAll('.dfc-clean-field')).find(field =>
        ['color', 'colour'].includes(normalize(field.querySelector('label')?.textContent))
      );
      const source = Array.from(info.querySelectorAll('select')).find(select =>
        !select.closest('variant-selects') &&
        normalize(select.closest('.dropdown-container')?.querySelector('label')?.textContent) === 'design color'
      );
      const oldField = clean.querySelector('[data-dfc-design-color-field]');
      if (!source || !colorField) {
        oldField?.remove();
        return;
      }
      let field = oldField;
      if (!field) {
        field = document.createElement('div');
        field.className = 'product-form__input product-form__input--dropdown';
        field.dataset.dfcDesignColorField = '';
        const label = document.createElement('label');
        label.className = 'form__label';
        label.textContent = 'Design Color';
        const wrapper = document.createElement('div');
        wrapper.className = 'select';
        const select = document.createElement('select');
        select.className = 'select__select dfc-design-color-select';
        select.id = 'dfc-design-color-' + (info.id || source.id);
        label.htmlFor = select.id;
        wrapper.append(select);
        const caret = colorField.querySelector('.svg-wrapper');
        if (caret) wrapper.append(caret.cloneNode(true));
        field.append(label, wrapper);
        colorField.after(field);
        // Design Color is an app property, not a Shopify variant option.
        select.addEventListener('change', event => {
          event.stopPropagation();
          const original = bindings.get(select);
          if (!original?.isConnected) return;
          original.value = select.value;
          original.dispatchEvent(new Event('input', { bubbles: true }));
          original.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      const control = field.querySelector('select');
      bindings.set(control, source);
      // Default an unanswered field only; preserve a customer's Black choice.
      if (!source.value) {
        const white = Array.from(source.options).find(option =>
          normalize(option.value) === 'white' && !option.disabled
        );
        if (white) {
          source.value = white.value;
          source.dispatchEvent(new Event('input', { bubbles: true }));
          source.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const signature = JSON.stringify(Array.from(source.options, option => [option.value, option.textContent.trim(), option.disabled]));
      if (control.dataset.options !== signature) {
        control.replaceChildren(...Array.from(source.options, option => {
          const copy = document.createElement('option');
          copy.value = option.value;
          copy.textContent = option.textContent.trim();
          copy.disabled = option.disabled;
          return copy;
        }));
        control.dataset.options = signature;
      }
      if (control.value !== source.value) control.value = source.value;
      control.disabled = source.disabled;
      const required = source.required || !!source.closest('.dropdown-container')?.querySelector('.mini-label-required');
      control.setAttribute('aria-required', String(required));
      const label = field.querySelector('label');
      const title = 'Design Color';
      if (label.textContent !== title) label.textContent = title;
      const originalField = source.closest('.dropdown-container');
      originalField.hidden = true;
      originalField.setAttribute('data-dfc-design-color-original', '');
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(arrange);
  }
  const start = () => {
    arrange();
    document.querySelectorAll('product-info').forEach(info => {
      new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
      info.addEventListener('change', schedule);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
